import {
  EVENT_LIST_CACHE_FIELDS,
  ORGANIZATION_PEOPLE_CACHE_FIELDS,
} from '@/client/exchanges/cacheExchange/constants';
import invalidateFields, {
  type FieldInvalidationCache,
} from '@/client/exchanges/cacheExchange/invalidateFields';

export default function delete_person_team_by_pk(
  _parent: unknown,
  _args: unknown,
  cache: FieldInvalidationCache,
  _info: unknown,
) {
  invalidateFields(
    [
      'team',
      'person_team',
      'person_team_aggregate',
      ...EVENT_LIST_CACHE_FIELDS,
      ...ORGANIZATION_PEOPLE_CACHE_FIELDS,
    ],
    cache,
  );
}
